import { Stack, Divider as ChakraDivider } from '@chakra-ui/react'

export function Divider() {
  return (
    <Stack py={10}>
      <ChakraDivider opacity={1} />
    </Stack>
  )
}
